import {
    onShowExpandButton,
    onOverflowOneRow,
    onLogShowExpandButton,
} from '../actions/internalActions';
import { logUsage } from 'owa-analytics';
import { DP_SHOW_EXPAND_BUTTON } from '../constants';
import getRecentAttachmentsPillsData from '../selectors/getRecentAttachmentsPillsData';
import { orchestrator } from 'satcheljs';

orchestrator(onOverflowOneRow, actionMessage => {
    const recentAttachmentsPillsData = getRecentAttachmentsPillsData(actionMessage.composeId);
    if (recentAttachmentsPillsData) {
        // flag to indicate the component to show or not the expand button
        onShowExpandButton(actionMessage.composeId, actionMessage.isOverFlow);

        // Need to log once that expand button is shown
        if (
            !recentAttachmentsPillsData.hasLoggedShowExpandButton &&
            recentAttachmentsPillsData.showExpandButton
        ) {
            logUsage(DP_SHOW_EXPAND_BUTTON);
            onLogShowExpandButton(actionMessage.composeId);
        }
    }
});
